const rulesReducer = (state = [], action) => {
  switch (action.type) {
    case "ADDRULE":
      return [...state, ...action.payload];

    default:
      return state;
  }
};

export default rulesReducer;
